import React from 'react';
import './App.css';
import Index from './component/Core/App';


function App() {
  return (
    <Index/>
  );
}

export default App;
